module.exports = __webpack_public_path__ + "dlssrvtyy/img/thai_slider-6.jpg?1e5043ed";